var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57277 9.30628L3.81388 10.0652C3.50625 9.44267 3.33337 8.74169 3.33337 8.00033C3.33337 7.72418 3.55723 7.50033 3.83337 7.50033C4.10952 7.50033 4.33337 7.72418 4.33337 8.00033C4.33337 8.46035 4.41809 8.90058 4.57277 9.30628ZM6.33337 7.54567L5.37994 8.4991C5.34937 8.33753 5.33337 8.17079 5.33337 8.00033V3.33366C5.33337 1.8609 6.52728 0.666992 8.00004 0.666992C9.43302 0.666992 10.602 1.79727 10.6641 3.21493L9.66671 4.21234V3.33366C9.66671 2.41318 8.92052 1.66699 8.00004 1.66699C7.07957 1.66699 6.33337 2.41318 6.33337 3.33366V7.54567ZM5.9352 12.1865L6.69409 11.4276C7.09979 11.5823 7.54002 11.667 8.00004 11.667C10.0251 11.667 11.6667 10.0254 11.6667 8.00033C11.6667 7.72418 11.8906 7.50033 12.1667 7.50033C12.4429 7.50033 12.6667 7.72418 12.6667 8.00033C12.6667 10.4087 10.8423 12.391 8.50004 12.6405V14.3337H10C10.2762 14.3337 10.5 14.5575 10.5 14.8337C10.5 15.1098 10.2762 15.3337 10 15.3337L9.99743 15.3337H8.50004H7.50004H6.00004C5.7239 15.3337 5.50004 15.1098 5.50004 14.8337C5.50004 14.5575 5.7239 14.3337 6.00004 14.3337H7.50004V12.6405C6.94333 12.5812 6.41587 12.424 5.9352 12.1865ZM7.50126 10.6204C7.66284 10.651 7.82957 10.667 8.00004 10.667C9.4728 10.667 10.6667 9.47308 10.6667 8.00033V7.45498L9.57514 8.54655C9.40833 9.02763 9.02734 9.40862 8.54626 9.57542L7.50126 10.6204Z",
    fill: "#DE2828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.5L0.5 15.5",
    stroke: "#DE2828",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMuted);
export default __webpack_public_path__ + "static/media/audio-muted.f997854696ad536c174825b3d742ebb2.svg";
export { ForwardRef as ReactComponent };